/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S4_IntroInputs */

const tr_iletisim_s4_intro = /** @type {(inputs: Iletisim_S4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura, abonelik ve muhasebe konuları için:`)
};

const en_iletisim_s4_intro = /** @type {(inputs: Iletisim_S4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For e-Fatura, subscription and accounting matters:`)
};

const de_iletisim_s4_intro = /** @type {(inputs: Iletisim_S4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Themen rund um e-Fatura, Abonnement und Buchhaltung:`)
};

const ru_iletisim_s4_intro = /** @type {(inputs: Iletisim_S4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По вопросам e-Fatura, подписки и бухгалтерии:`)
};

/**
* | output |
* | --- |
* | "For e-Fatura, subscription and accounting matters:" |
*
* @param {Iletisim_S4_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s4_intro = /** @type {((inputs?: Iletisim_S4_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S4_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s4_intro(inputs)
	if (locale === "de") return de_iletisim_s4_intro(inputs)
	if (locale === "ru") return ru_iletisim_s4_intro(inputs)
	return tr_iletisim_s4_intro(inputs)
});